'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Copyright (c) 2015-present, Zippy Technologies
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                   */

var _assign = require('../../../common/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getMinMaxSize = require('../../../common/getMinMaxSize');

var _getMinMaxSize2 = _interopRequireDefault(_getMinMaxSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prepareStyle(props, state) {
  var style = {};

  if (props.subMenu) {
    (0, _assign2.default)(style, props.submenuStyle);
  } else {
    (0, _assign2.default)(style, props.style);
  }

  if (props.at) {
    var isArray = Array.isArray(props.at);
    var coords = {
      left: isArray ? props.at[0] : props.at.left === undefined ? props.at.x || props.at.pageX : props.at.left,

      top: isArray ? props.at[1] : props.at.top === undefined ? props.at.y || props.at.pageY : props.at.top
    };

    (0, _assign2.default)(style, coords);
  }

  if (state.positionStyle && props.visible !== false) {
    style = _extends({}, style, state.positionStyle);
  }

  var minMaxSize = (0, _getMinMaxSize2.default)(props);
  (0, _assign2.default)(style, minMaxSize);

  if (props.padding) {
    (0, _assign2.default)(style, { padding: props.padding });
  }

  if (props.border) {
    (0, _assign2.default)(style, { border: props.border });
  }

  if (typeof props.shadow === 'string') {
    (0, _assign2.default)(style, { boxShadow: props.shadow });
  }
  if (props.borderRadius) {
    (0, _assign2.default)(style, { borderRadius: props.borderRadius });
  }
  if (props.width) {
    (0, _assign2.default)(style, { width: props.width });
  }

  if (props.enableAnimation && (state.transitionEnded || state.transitionStart)) {
    (0, _assign2.default)(style, {
      transitionDuration: props.fadeDuration + 'ms',
      transitionTimingFunction: props.transitionTimingFunction
    });
  }

  return style;
}

exports.default = prepareStyle;